<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 content-class="round-2xl")
  v-card
    v-card-title.pa-0
    div.px-6.pt-2
      .text-lg.font-medium.mt-6 {{ $t('delete_confirmation', { text: $t('service').toLowerCase() }) }}
      .text-md.mt-4 {{ $t('delete_confirmation_desc', { text: $t('service').toLowerCase() }) }}
      .text-md.mt-2 {{ $t('click_confirm_to_proceed') }}
    v-divider.mt-6
    v-card-actions.px-6.py-3
      v-btn.button-md.neutral700--text.px-0(@click="cancel" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="deleteItem" :loading="isLoading" color="danger500" depressed dark) {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DeleteServiceDialog',
  props: ['open', 'service', 'isHq'],
  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    deleteItem() {
      this.isLoading = true
      const endpoint = this.isHq
        ? `/clinics/${this.company.slug}/hq/services/${this.service.id}`
        : `/clinics/${this.company.slug}/services/${this.service.id}`
      this.$axios.delete(endpoint)
        .then(() => {
          this.updateActivityLog(endpoint, 'DELETE', this.service.id)
          this.showMessage(['success', this.$t('success_message.service_deleted_successfully')])
          this.$emit('deleted')
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateActivityLog (endpoint, method, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'service',
        activity: 'Delete service',
        raw_data: { endpoint, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
    cancel () {
      this.showDialog = false
      this.$emit('closed')
    }
  }
}
</script>